import { useEffect, useState, useRef } from "react"
import { useNavigate } from "react-router-dom"
import { useInView } from 'react-hook-inview'
import { HomepageReactGAHandlers } from "../ReactGAHandlers"

import heroImage from '../../../custom_assets/home/hero/hero.jpg'
import ecInsights from '../../../custom_assets/home/ec_insights.png'
import ecInsightsMobile from '../../../custom_assets/home/ec_insights_mobile.png'

import hero1 from '../../../custom_assets/home/hero/hero_1.png'
import hero1Mobile from '../../../custom_assets/home/hero/hero1_mobile.png'

import hero2 from '../../../custom_assets/home/hero/hero_2.png'
import hero2Mobile from '../../../custom_assets/home/hero/hero2_mobile.png'

import hero4 from '../../../custom_assets/home/hero/hero_4.png'
import hero4Mobile from '../../../custom_assets/home/hero/hero4_mobile.png'

import { pageRoutes } from "../dictionary"


export const Hero = ({ user, isMobile }) => {

  let navigate = useNavigate()

  const { handleHomepageClick } = HomepageReactGAHandlers()

  const slides = [
    { text: "Get into the most selective colleges", image: isMobile ? hero1Mobile : hero1 },
    { text: "Optimize your college choices", image: isMobile ? hero2Mobile : hero2 },
    { text: "Discover needle-moving extracurriculars", image: isMobile ? ecInsightsMobile : ecInsights },
    { text: "Pinpoint the perfect majors", image: isMobile ? hero4Mobile : hero4 },
  ];

  const [slideIndex, setSlideIndex] = useState(0);
  const [text, setText] = useState("");
  const [charIndex, setCharIndex] = useState(0);
  const textRef = useRef<HTMLDivElement | null>(null);
  // const imageRefs = useRef<HTMLImageElement[]>([]);

  useEffect(() => {
    const currentText = slides[slideIndex].text;

    if (charIndex < currentText.length) {
      const timeout = setTimeout(() => {
        setText(currentText.substring(0, charIndex + 1));
        setCharIndex((prev) => prev + 1);
      }, 60);

      return () => clearTimeout(timeout);
    } else {
      const delay = setTimeout(() => {
        setSlideIndex((prev) => (prev + 1) % slides.length);
        setCharIndex(0);
        setText("");
      }, 2500);

      return () => clearTimeout(delay);
    }
  }, [charIndex, slideIndex]);

  const [heroController, setHeroController] = useState({
    hero: 0,
    active: false,
    timer: 0
  })
  const [heroRef, isVisible] = useInView({ threshold: 0.5 })

  useEffect(() => {
    if (isVisible && heroController.active == false) {
      setHeroController(prevState => ({
        ...prevState, active: true
      }));
    }

    if (!isVisible && heroController.active == true) {
      setHeroController(prevState => ({
        ...prevState, timer: 0, active: false
      }));
    }
  }, [isVisible])

  const ctaButton = <button className="dca-home-hero-button-margin dca-home-hero-cta-button"
    onClick={() => {
      handleHomepageClick('CTA Hero');
      navigate(pageRoutes.dashboard)
    }}
    style={{ width: user?.dashboardAlertShown == true ? '216px' : '' }}>
    {user?.dashboardAlertShown == true ? <span className="d-flex flex-row justify-content-center align-items-center" style={{ whiteSpace: 'nowrap' }}>My Dashboard <i
      className="fa-solid fa-arrow-right"
      style={{
        color: 'black',
        fontWeight: 'bold',
        paddingLeft: '8px',
        fontSize: '1.2rem'
      }}></i></span> : <span className="d-flex flex-row justify-content-center align-items-center" style={{ whiteSpace: 'nowrap' }}>Get Started</span>}
  </button>

  return <div className="dca-home-hero-container-image">
    <div className="dca-home-hero-container">
      <div className="dca-home-hero-text-container">
        <span className="dca-home-hero-title-text" style={{ whiteSpace: 'nowrap' }}>Utilize Data & AI to</span>

        <span ref={textRef} className="dca-home-hero-typing-text">
          <div className="dca-home-hero-text-wrapper">
            {text}
          </div>

          {!isMobile && ctaButton}
        </span>


        {isMobile && ctaButton}
      </div>

      <div className="dca-home-hero-image-container">
        {slides.map((slide, index) => (
          <img
            key={index}
            src={slide.image}
            className={`dca-home-hero-img index${index} ${index === slideIndex ? "fadeIn" : "fadeOut"}`}
            alt="Home_Hero_Animation"
          />
        ))}
      </div>

    </div>
  </div>
}



